import { SubscriptionBaseComponent } from './../../../shared/subscriptionBase/subscription-base';
import { FederationsService } from 'app/shared/services/federations/federations.service';
import { FaiconService } from './../../../shared/services/faicon/faicon.service';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { Federation } from 'app/shared/models/class/federation/federation';
import { ThemePalette } from '@angular/material/core';

export interface DialogData {
  club?: ClubDetails;
  action: string;
}

type switchOptions = {
  [key: string]: any
};

@Component({
  selector: 'app-opendialog-add-club',
  templateUrl: './opendialog-add-club.component.html',
  styleUrls: ['./opendialog-add-club.component.scss']
})
export class OpendialogAddClubComponent extends SubscriptionBaseComponent implements OnInit {

  addClubForm: UntypedFormGroup;
  confirm = false;
  userConnected: any;
  title: string;
  btnConfirm: string;
  text: string;
  federations: Federation[] = [];
  isLoading = false;
  isNetworkHeadValue = false;
  values = [{ value: false, checked: true}, { value: true, checked: false}];
  color: ThemePalette = 'primary';

  constructor(
    public dialogRef: MatDialogRef<OpendialogAddClubComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: UntypedFormBuilder,
    private clubService: ClubService,
    private authService: AuthService,
    private faIconService: FaiconService,
    private federationsSrv: FederationsService

  ) {
    super()
  }

  ngOnInit(): void {
    this.initComponent();
  }

  onSubmit(): void {
    const club: ClubDetails = {
      clubCode: this.f.clubCode.value,
      clubName: this.f.clubName.value,
      postalCode: this.f.postalCode.value,
      city: this.f.city.value,
      address: this.f.address.value,
      addressNumber: this.f.addressNumber.value,
      box: this.f.box.value,
      contactPerson: this.f.contactPerson.value,
      smsPhoneNumber: this.f.smsPhoneNumber.value,
      mail: this.f.mail.value,
      phoneNumber: this.f.phoneNumber.value,
      priorities: 0,
      isNetworkHead: this.isNetworkHeadValue
    };

    if (this.userConnected.role !== 'AdminMSR') {
      let federations = [];

      this.f.federation?.value?.map(fede => {
        let federation = {
          federationKey: fede.federationKey,
          label: fede.label
        }

        federations.push(federation.federationKey);
      })

      club.federationKeys = federations.join(';');
      club.limitPriorities = this.f.limitPriorities.value;
    }


    switch (this.data.action) {
      case 'new':

        this.clubService.addClub(club).subscribe({
          next: () => {
            this.confirm = true;
            setTimeout(() => {
              this.dialogRef.close(true);

            }, 3000);
          }
        });
        break;
      case 'update':
        club.clubKey = this.data.club.clubKey;

        this.clubService.updateClub(club).subscribe({
          next: () => {
            this.confirm = true;
            setTimeout(() => {
              this.dialogRef.close(true);

            }, 3000);
          }
        });
        break;

      default:
        break;
    }
  }

  private getLabel(type: string): string {
    const title: switchOptions = {
      new: {
        title: 'Ajouter un acteur',
        confirm: 'Ajouter',
        text: 'Acteur ajouté'
      },
      update: {
        title: `Mettre à jour l'acteur`,
        confirm: 'Mettre à jour',
        text: 'Acteur mis à jour',
      },
    };
    return title[this.data.action][type];
  }

  get f() {
    return this.addClubForm.controls;
  }

  selectValue(event: any): void {
    this.isNetworkHeadValue = event.value;
  }

  private setValueForm(): void {
    this.f.clubCode.setValue(this.data.club?.clubCode);
    this.f.clubName.setValue(this.data.club?.clubName);
    this.f.postalCode.setValue(this.data.club?.postalCode);
    this.f.city.setValue(this.data.club?.city);
    this.f.address.setValue(this.data.club?.address);
    this.f.addressNumber.setValue(this.data.club?.addressNumber);
    this.f.box.setValue(this.data.club?.box);
    this.f.mail.setValue(this.data.club?.mail);
    this.f.contactPerson.setValue(this.data.club?.contactPerson);
    this.f.smsPhoneNumber.setValue(this.data.club?.smsPhoneNumber);
    this.f.phoneNumber.setValue(this.data.club?.phoneNumber);

    this.f.clubCode.disable();

    if (this.userConnected.role !== 'AdminMSR') {
      this.f.limitPriorities.setValue(this.data.club?.limitPriorities);
      // if (this.data.club.federation?.length > 0) {

      //   this.data.club.federation.map(fede => {
      //     this.addFederation(fede);
      //   })
      // }
    }
    if (this.userConnected.role === 'AdminMSR') {
      this.f.clubName.disable();
    }
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.title = this.getLabel('title');
    this.btnConfirm = this.getLabel('confirm');
    this.text = this.getLabel('text');

    if (this.userConnected.role !== 'AdminMSR') {
      this.initSub();
    } else {
      this.initForm();
    }
  }

  private initSub() {
    // this.isLoading = true;
    this.initForm();

    // this.subscription.add(
    //   this.federationsSrv.getFederations().subscribe(federationsFromSrv => {
    //     this.federations = federationsFromSrv;
    //     this.initForm();

    //     this.isLoading = false;
    //   })
    // )
  }

  private initForm(): void {

    if (this.userConnected.role === 'admin') {
      this.addClubForm = this.formBuilder.group({
        clubCode: ['', Validators.required],
        clubName: ['', Validators.required],
        postalCode: ['', Validators.required],
        city: ['', Validators.required],
        address: ['', Validators.required],
        addressNumber: ['', Validators.required],
        box: [''],
        mail: ['', Validators.required],
        contactPerson: ['', Validators.required],
        smsPhoneNumber: ['', Validators.required],
        phoneNumber: ['', Validators.required],
        limitPriorities: ['', Validators.required]
        // federation: this.formBuilder.array([], Validators.required)
      });
    } else if (this.userConnected.role === 'AdminMSR') {
      this.addClubForm = this.formBuilder.group({
        clubCode: ['', Validators.required],
        clubName: ['', Validators.required],
        postalCode: ['', Validators.required],
        city: ['', Validators.required],
        address: ['', Validators.required],
        addressNumber: ['', Validators.required],
        box: [''],
        mail: ['', Validators.required],
        contactPerson: ['', Validators.required],
        smsPhoneNumber: ['', Validators.required],
        phoneNumber: ['', Validators.required]
      });
    }

    if (this.data.action === 'update') {
      this.setValueForm();
      // Network head
      this.values.forEach(val => {
        if (val.value === this.data.club?.isNetworkHead) {
          val.checked = true;
        }
      });
    }
    // else if (this.userConnected.role !== 'club') {
    //   this.addFederation();
    // }
  }

  getArray(array: string): UntypedFormArray {
    return this.addClubForm.get(array) as UntypedFormArray;
  }

  // addFederation(federation?): void{
  //   let oneFederation = federation ? this.formBuilder.control(federation) : this.formBuilder.control(null);

  //   oneFederation.setValidators(Validators.required);

  //   this.getArray('federation').push(oneFederation);
  // }

  // removeFederation(index) {
  //   this.getArray('federation').removeAt(index);
  // }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

}
